export class ProfileModel {
  image: string;
  name: string;
  role: string;
  description: string;
  email: string;
  emailVerified: boolean;
  provider: string;
  phoneNumber: string;
  stopPubMensuel: boolean;
  stopPubAnnuel: boolean;
  dateDebutStopPub: any;
  token:any;

}
